import { render, staticRenderFns } from "./VideoRoomGiftModal.vue?vue&type=template&id=018fd994&scoped=true"
import script from "./VideoRoomGiftModal.vue?vue&type=script&lang=js"
export * from "./VideoRoomGiftModal.vue?vue&type=script&lang=js"
import style0 from "./VideoRoomGiftModal.vue?vue&type=style&index=0&id=018fd994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018fd994",
  null
  
)

export default component.exports